function dm_c_11_people_cards() {

    var page = 2;
    var currentCategory = '';

    function load_people_stories(category, reset = false) {
        if (reset) {
            page = 1;
            $('.people-row').empty();
        }

        $('#people-plus').hide();
        $('#people-spinner').show();

        $.ajax({
            url: people_data.ajaxurl,
            type: 'post',
            data: {
                action: 'load_more_people',
                page: page,
                category: category,
                nonce: people_data.nonce
            },
            success: function(response) {
                if(response.html) {
                    $('.people-row').append(response.html);
                    $('#people-spinner').hide();
                    $('#people-plus').show();
                    page++;
                    if (response.hide_button || $(response.html).length < 3) {
                        $('#people-load-more').addClass('btn-hide-invis');
                    } else {
                        $('#people-load-more').removeClass('btn-hide-invis');
                    }
                } else {
                    $('#people-load-more').addClass('btn-hide-invis');
                    $('#people-spinner').hide();
                    $('#people-plus').show();
                }
            },
            error: function() {
                $('#people-spinner').hide();
                $('#people-plus').show();
            }
        });
    }

    $('#people-load-more').off('click.dmPeopleStories').on('click.dmPeopleStories', function(e) {
        e.preventDefault();
        load_people_stories(currentCategory);
    });

}

export { dm_c_11_people_cards };
